import { useSelector } from 'react-redux';


/**
 * Returns the data relative to a program session selected by ID
 * @param  {Number} eventId   Event ID
 * @param  {Number} programId Program ID
 * @return {object}           Program data
 */

export function useProgramSession(eventId, programId) {
    return useSelector(state => state.events[eventId]?.schedule.indexed[programId]);
}
